import type { FC } from 'react';
import { useMeasureElement } from '@wix/da-hooks/pkg/useMeasureElement/useMeasureElement';
import { useSelector } from 'react-redux';
import { getAppData } from '../../../../selectors/studio/apps';
import { Props } from '../../StudioDeviationList';
import { StudioDeviationListContext } from '../../context';
import ApplicationListItem from '../../items/ApplicationListItem';
import BaseList from '../BaseList';

import s from './ApplicationList.scss';

const ApplicationList: FC<Props> = ({ deviations, selectProps }) => {
  const appData = useSelector(getAppData);
  const { ref: actionsColRef, dimensions: actionsDimensions } =
    useMeasureElement({
      throttle: 250,
      throttleOptions: { trailing: true },
    });

  return (
    <StudioDeviationListContext.Provider
      value={{
        actionsColRef,
        actionsColWidth:
          actionsDimensions.width && Math.floor(actionsDimensions.width),
      }}
    >
      <BaseList
        className={s['list']}
        results={deviations}
        renderItem={(deviation, idx) => (
          <ApplicationListItem
            key={deviation.deviationId}
            deviation={deviation}
            appData={appData[deviation.deviationId]}
            offset={idx}
            selected={selectProps.selected}
            onSelect={selectProps.onSelect}
          />
        )}
      />
    </StudioDeviationListContext.Provider>
  );
};
ApplicationList.displayName = 'ApplicationList';

export default ApplicationList;
